module.exports = __webpack_public_path__ + "static/bi-mobile-screen2-5e30666fcca95fd66cbb31a47aefd2bd.jpeg";